import React, { FC, useEffect } from 'react';
import { RouteComponentProps, Switch, Route, useHistory } from 'react-router-dom';
import { Layout } from 'antd';

import Sider, { createPath } from './Sider';
import {
  AuthenticateWithPassword,
  CompanyInformation,
  ConfirmEmail,
  ConfirmPhoneNumber,
  Country,
  CreateAccount,
  PersonalInfo,
  CompanyContacts,
} from './components';
import CreatePassword from './components/CreatePassword';
import CompanyAddress from './components/CompanyAddress';
import AccountExist from './components/AccountExist';
import { ChangeLanguage } from '~/components';
import { getFirstUnskipPage, useOnboardingState } from '~/hooks/onboarding';
import { auth } from '~/api/axios';

const { Content } = Layout;

const Onboarding: FC<RouteComponentProps> = (props) => {
  const history = useHistory();
  const [onboardingState] = useOnboardingState();
  const firstUnskipPage = getFirstUnskipPage(onboardingState);
  useEffect(() => {
    if (firstUnskipPage === 'personalInfo') {
      auth.deleteToken();
    }
    history.push(createPath(firstUnskipPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <ChangeLanguage />
      <Layout className="Onboarding">
        <Sider {...props} />
        <Content className="Onboarding-Content">
          <Switch>
            <Route exact path={createPath('personalInfo')}>
              <PersonalInfo {...props} name="personalInfo" />
            </Route>
            <Route exact path={createPath('personalInfo/confirm')}>
              <ConfirmPhoneNumber {...props} name="personalInfo/confirm" />
            </Route>
            <Route exact path={createPath('personalInfo/authenticate')}>
              <AuthenticateWithPassword {...props} name="personalInfo/authenticate" />
            </Route>
            <Route exact path={createPath('country')}>
              <Country {...props} name="country" />
            </Route>
            <Route exact path={createPath('companyInformation')}>
              <CompanyInformation {...props} name="companyInformation" />
            </Route>
            <Route exact path={createPath('companyInformation/contacts')}>
              <CompanyContacts {...props} name="companyInformation/contacts" />
            </Route>
            <Route exact path={createPath('companyAddress')}>
              <CompanyAddress {...props} name="companyAddress" />
            </Route>
            <Route exact path={createPath('createAccount')}>
              <CreateAccount {...props} name="createAccount" />
            </Route>
            <Route exact path={createPath('createAccount/confirm')}>
              <ConfirmEmail {...props} name="createAccount/confirm" />
            </Route>
            <Route exact path={createPath('createAccount/password')}>
              <CreatePassword {...props} name="createAccount/password" />
            </Route>
            <Route exact path={createPath('accountExist')}>
              <AccountExist {...props} name="accountExist" />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </>
  );
};

export default Onboarding;
